import qs from "qs";

import { sendGA4Tracking } from "~/components/tracking/google-analytics-4/apis";
import type { OnboardingCTAType } from "~/components/tracking/google-analytics-4/types";
import { sendGATracking } from "~/components/tracking/google-analytics/apis";

import type { GaSlideImpressionType, OnboardQueryStringPayload, UserType } from "./types";

export const useNeedToShowOnboarding = () => {
  const parsedQueryString = qs.parse(window.location.search, {
    ignoreQueryPrefix: true,
  }) as unknown as OnboardQueryStringPayload;
  return parsedQueryString.onboard === "true";
};

interface HandleSlideTrackImpressionParameters {
  ctaType: OnboardingCTAType;
  currentSlide: number;
  impressionType: GaSlideImpressionType;
  isLastSlide: boolean;
  label?: string;
  userType: UserType;
}

export const useTrackImpression = () => {
  const handleSlideTrackImpression = (parameters: HandleSlideTrackImpressionParameters) => {
    const {
      ctaType,
      currentSlide,
      impressionType,
      isLastSlide,
      label = window.location.href,
      userType,
    } = parameters;

    sendGATracking({
      action: `Onboarding/Pop-up/${userType}/${impressionType}/Impressions`,
      category: "Onboarding/Pop-up",
      label,
    });

    sendGA4Tracking({
      action: "imp",
      category: "onboarding",
      customized_parameters: {
        cta_type: ctaType,
        step: currentSlide,
        user_type: userType,
      },
      subcategory: "",
    });

    if (isLastSlide) {
      sendGATracking({
        action: `Onboarding/Pop-up/${userType}/Complete`,
        category: "Onboarding/Pop-up",
        label,
      });
    }
  };

  return {
    handleSlideTrackImpression,
  };
};
